import { brazilPhoneDigits } from "@/lib/validation/brazil-phone"

const BRAZIL_COUNTRY_CODE = "55"

/**
 * Converte telefone BR (display ou dígitos) para E.164 (+55...).
 * Retorna null se inválido (menos de 10 ou mais de 11 dígitos nacionais).
 */
export function brazilPhoneToE164(raw: string | null | undefined): string | null {
  const digits = brazilPhoneDigits(raw ?? "")
  if (digits.length < 10 || digits.length > 11) {
    return null
  }
  if (digits.length === 11 && digits[2] !== "9") {
    return null
  }
  return `+${BRAZIL_COUNTRY_CODE}${digits}`
}

/** Meta Cloud API espera `to` sem '+' — apenas dígitos E.164. */
export function e164ToWhatsAppRecipient(e164: string): string {
  return e164.replace(/\D/g, "")
}

export function firstNameFromFullName(fullName: string | null | undefined): string {
  const trimmed = fullName?.trim()
  if (!trimmed) return "cliente"
  return trimmed.split(/\s+/)[0] || "cliente"
}
